export const TYPE_OPTIONS = [
  { value: "Marco", label: "Marco" },
  { value: "Específico", label: "Específico" },
  { value: "Adenda o Anexo", label: "Adenda o Anexo" },
  // agregá más tipos si hay
];
